<template>
    <div>
        {{option}}
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    name : "OptionDisplay",
    props : {
        value : {
            required : false,
        },
        field : {
            type : Object,
            required : true,
        },
    },
    computed : {
        option () {
            const option = _.findWhere(this.field.options, { value : this.value });
            return option ? option.label : '';
        },
    },
}
</script>

<style scoped>

</style>
